<template>
<div class="MeterViewDiagram">
  <div class="MeterViewDiagram-header">
    <el-date-picker
      v-model="mainObj.read_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM"
      @change="renderData(mainObj.map_id)"
      placeholder="选择月">
    </el-date-picker>
    <el-button size="mini" @click="computeDosageNumber">重新计费</el-button>
    <el-button size="mini" @click="download">保存架构</el-button>
  </div>

  <div id="mountNode-order"></div>
  <div class="MeterTreeWin">
    <MeterTreeComponent height="100vh" :project_id="mainObj.project_id" ref="MeterTreeComponentRef" @onClick="onClickMeter" />
  </div>
  <MeterOrderDrawer ref="MeterOrderDrawerRef" />
</div>
</template>

<script>
import G6 from "@antv/g6";
import {tooltip,menu} from "./common/MeterOrderG6";
import MeterTreeComponent from "../../meter/components/MeterTreeComponent";
import {Loading} from "element-ui";
import MeterOrderFlowHelp from "../../../common/MeterOrderFlowHelp";
import MeterHttp from "../../../common/MeterHttp";
import MeterOrderDrawer from "./MeterOrderDrawer";


export default {
  name: "MeterOrderDiagram",
  components: {MeterOrderDrawer, MeterTreeComponent},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return {
      defaultConfig:{
        width: (window.innerWidth),
        height: (window.innerHeight - 120),
        modes: {
          default: ['zoom-canvas', 'drag-canvas']
        },
        fitView: true, // 开启画布自适应。开启后图自动适配画布大小
        animate: true,
        // 节点样式
        defaultNode: {
          type: 'flow-rect', // flow-rect我们自定义的样式名称，告诉画板要引用哪个模块
          style: {
            fill: '#0095FF' // 默认的模板填充色
          },
          // 默认的模板的文字的填充色
          labelCfg: {
            style: {
              fill: '#fff',
              fontSize: 20,
              fontWeight: 800
            }
          }
        },
        // 线的样式
        defaultEdge: {
          type: 'polyline',
          size: 3, // 粗细
          style: {
            stroke: '#CED4D9'
          }
        },
        // 布局
        layout: {
          type: 'compactBox', // 布局类型
          direction: 'TB', // 展开的方向
          // 与子节点的相差的高度
          getHeight: () => {
            return 310
          },
          // 与子节点的相差的宽度
          getWidth: () => {
            return 250
          }
        },
        maxZoom: 1, // 展开时的放缩比例
        plugins: [tooltip,menu(this)]//toolbar
      },
      meter_line:{
        label:'线路架构图',
        type: 'rect',
        size: [300, 40],
        anchorPoints: [
          [0.5, 0],
          [0.5, 1]
        ],
        getHeight: () => {
          return 10
        },
        getWidth: () => {
          return 150
        },
        children:[],
      },
      dialogVisible:false,
      excel_value:"",
      treeGraph:null,
      meter_order_list:[]
    }
  },
  created() {

  },
  mounted() {
    const that=this;
    that.onLoad(list=>{
      that.meter_order_list=list;
      that.initData()
    })
  },
  methods:{
    initData(){
      const that=this;
      that.initGraph()
    },
    reData(){
      const that=this;
      let meter_line=getHeaderTree(that.mainObj.map_id,ERP.reJson(that.meter_order_list));
      that.meter_line.children=ERP.reJson(meter_line);
      that.treeGraph.data(that.meter_line) // 加载数据
      setTimeout(function () {
        that.treeGraph.render() // 渲染
      },200);
    },
    initGraph(){
      const that=this;
      const colors = {
        A: '#D6F3DA',
        B: '#FDEBD3',
        C: '#D7D7D7'
      };
      // 默认配置
      const defaultConfig = this.defaultConfig;
      // 自定义节点和边
      const registerFn = () => {
        /**
         * 自定义节点
         */
        G6.registerNode(
          'flow-rect', // 自定义的节点名称，在上面进行引用
          {
            shapeType: 'flow-rect',
            // 这里涉及到模板的生命周期函数，官网上面有详细的讲解
            draw(cfg, group) {
              // 自定义模板
              let rectConfig = {
                width: 250,
                height: 300,
                fill: '#fff',
                shadowOffsetX: 0, // 模板阴影的X轴偏移量
                shadowOffsetY: 0, // 模板阴影的Y轴偏移量
                shadowColor: '#999',
                shadowBlur: 10
              }
              let is_ft_xb=false;
              let meter_number=cfg.number||'';
              if(meter_number.length===14){
                let ft_type=meter_number.slice(6,8);
                is_ft_xb=ft_type==='00';
              }
              if(is_ft_xb){
                rectConfig={
                  ...rectConfig,
                  stroke: '#3b6ed9', // 边框色
                  lineWidth: 2, // 边框宽度
                  lineDash: [10, 5], // 设置虚线，10是线的长度，5是间隔的长度
                }
              }
              // 规定边界，便于定位
              const nodeOrigin = {
                x: -rectConfig.width / 2,
                y: -rectConfig.height / 2
              }
              // 规定文字位置，对齐方式
              const textConfig = {
                textAlign: 'left',
                textBaseline: 'bottom'
              }
              // 初始化模板
              const rect = group.addShape('rect', {
                attrs: {
                  x: nodeOrigin.x,
                  y: nodeOrigin.y,
                  ...rectConfig
                }
              })

              let width=rectConfig.width;
              let height=50;

              // 背景板
              group.addShape('rect', {
                attrs: {
                  x: nodeOrigin.x, // x轴位置
                  y: nodeOrigin.y, // y轴位置
                  width: width,
                  height: height,
                  // radius: [0, 0, rectConfig.radius, rectConfig.radius],//锐角化
                  fill: colors[cfg.colorIndex] // 填充色
                }
              })

              group.addShape('rect', {
                attrs: {
                  x: 4 + nodeOrigin.x,
                  y: 30 + nodeOrigin.y,
                  width: rectConfig.width-10,
                  height: 1,
                  fill: '#333',
                  opacity: 0.35
                }
              })

              // 线
              group.addShape('text', {
                attrs: {
                  ...textConfig,
                  x: 9 + nodeOrigin.x,
                  y: 25 + nodeOrigin.y,
                  text: cfg.name,
                  height: 18,
                  fontSize: 16,
                  fontWeight: 800,
                  fill: '#333',
                  opacity: 1
                }
              })

              let rate_val=25;
              let top_x=30;

              // 编号
              that.setLabelValue(group,textConfig,nodeOrigin,"编号",cfg.number,top_x+(rate_val));
              // 能耗类型
              that.setLabelValue(group,textConfig,nodeOrigin,"能耗类型",cfg.energy,top_x+(rate_val*2));
              // 下级数量
              that.setLabelValue(group,textConfig,nodeOrigin,"表产生量",cfg.dosage_number,top_x+(rate_val*3));

              that.setLabelValue(group,textConfig,nodeOrigin,"本表线损",cfg.x_dosage_number,top_x+(rate_val*4));

              that.setLabelValue(group,textConfig,nodeOrigin,"上级线损",cfg.x_only_dosage_number,top_x+(rate_val*5));

              that.setLabelValue(group,textConfig,nodeOrigin,"累计线损",cfg.x_total_dosage_number,top_x+(rate_val*6),'#3b6ed9');

              that.setLabelValue(group,textConfig,nodeOrigin,"线损占比",(Math.floor(cfg.proportion*10000)/100)+" %",top_x+(rate_val*7),'#3b6ed9');

              that.setLabelValue(group,textConfig,nodeOrigin,"总分摊量",cfg.total_dosage_number,top_x+(rate_val*8),'#ff4343');

              that.setLabelValue(group,textConfig,nodeOrigin,"计费总额",cfg.total_amount,top_x+(rate_val*9),'#ff4343');

              that.setLabelValue(group,textConfig,nodeOrigin,"分摊总额",cfg.allocated_amount,top_x+(rate_val*10),'#ff4343');

              // 跳转
              // group.addShape('image', {
              //   attrs: {
              //     x: -nodeOrigin.x - 36,
              //     y: 12 + nodeOrigin.y,
              //     img: require('@/assets/logo.png'),
              //     width: 26,
              //     height: 26,
              //     cursor: 'pointer'
              //   },
              //   name: 'deleteItem'
              // })



              // 如果不需要动态增加或删除元素，则不需要 add 这两个 marker
              // group.addShape('marker', {
              //   attrs: {
              //     x: -width/2+20,
              //     y: height+height/2-20,
              //     r: 10,
              //     stroke: '#73d13d',
              //     cursor: 'pointer',
              //     symbol: EXPAND_ICON,
              //   },
              //   // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //   name: 'add-item',
              // });
              //
              // group.addShape('marker', {
              //   attrs: {
              //     x: width/2-20,
              //     y: height+height/2-20,
              //     r: 10,
              //     stroke: '#ff4d4f',
              //     cursor: 'pointer',
              //     symbol: COLLAPSE_ICON,
              //   },
              //   // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              //   name: 'remove-item',
              // });


              return rect
            },
            // 定义锚点，G6会自动连接两个节点的最近的锚点
            getAnchorPoints() {
              return [
                // [0, 0.5], // 左侧中间
                // [1, 0.5], // 右侧中间
                [0.5, 0], // 上侧中间
                [0.5, 1] // 下侧中间
              ]
            }
          },
          'rect'
        )
      };
      registerFn();
      // 画布主体
      that.treeGraph = new G6.TreeGraph({
        container: 'mountNode-order', // 制定画布的容器
        ...defaultConfig
      })

      that.treeGraph.on('node:click', (evt) => {
        const { item, target } = evt;
        const targetType = target.get('type');
        const name = target.get('name');
        const model = item.getModel();
        that.$refs.MeterOrderDrawerRef.show(model);
      });

      // deleteItem: 对于需要单独操作的元素，请在定义数据的时候定义nama值，这样才可以定位到指定元素
      that.treeGraph.on('deleteItem:click', (ev) => {
        const shape = ev.target
        const node = ev.item
        console.log(shape)
        console.log(node)
      })

      that.reData();

      const container = document.getElementById('container');
      if (typeof window !== 'undefined')
        window.onresize = () => {
          if (!that.treeGraph || that.treeGraph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          that.treeGraph.changeSize(container.scrollWidth, container.scrollHeight);
        };


    },
    setLabelValue(group,textConfig,nodeOrigin,label,value,y,clo='#555'){
      group.addShape('text', {
        attrs: {
          ...textConfig,
          x: 9 + nodeOrigin.x,
          y: y + nodeOrigin.y,
          text: label,
          fontSize: 16,
          fill: '#555',
          opacity: 1
        }
      })
      group.addShape('text', {
        attrs: {
          ...textConfig,
          x: -(150 + nodeOrigin.x),
          y: y + nodeOrigin.y,
          text: value,
          fontSize: 16,
          fontWeight: 800,
          fill: clo,
          opacity: 1
        }
      })
    },
    download(){
      const that=this;
      let time=(new Date()).getTime().toString()
      that.treeGraph.downloadFullImage('仪表架构图_'+time, 'image/png', {
        backgroundColor: '#FFFFFF',
        padding: [30, 15, 15, 15],
      });
    },
    onLoad(callback){
      const that=this;
      MeterHttp.post("MeterOrder/getMapTree",{
        project_id:that.mainObj.project_id,
        meter_id:that.mainObj.map_id,
        is_editor:that.isEditor?1:0,
        read_month:that.mainObj.read_month
      },ret=>{
        if(ret.code){
          typeof callback==="function"&&callback(ret.data)
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
      })
    },
    renderData(meter_id){
      const that=this;
      that.mainObj.map_id=meter_id;
      that.onLoad(list=>{
        that.meter_order_list=list;
        that.reData()
      })
    },
    onClickMeter(node){
      // this.$emit("onClickMeter",node)
      this.renderData(node.id)
    },
    computeDosageNumber(){
      const that = this;
      if(!that.mainObj.project_id){
        that.$message.error('请选择项目');
        return false;
      }
      if(!that.mainObj.read_month){
        that.$message.error('请选择抄表月份');
        return false;
      }
      let loadingInstance = Loading.service({ fullscreen: true });
      MeterHttp.post("MeterOrder/computeDosageNumber",{
        project_id:that.mainObj.project_id,
        apportion_meter_types:'1,2',
        read_month:that.mainObj.read_month,
        user_type:(that.$route.query.type||0),
      }, res => {
        loadingInstance.close();
        if (res.code) {
          that.renderData(that.mainObj.map_id)
        }
      })
    },
  }
}


const meterOrderItem = (ret) => {
  let energy_obj={1:"业主能耗",2:"物业能耗",3:"分摊能耗"};
  let apportion_type_obj={
    average:"平均分摊",
    area:"面积分摊",
    usage:"用量分摊",
    floor:"楼层分摊",
    currency:"通用分摊"
  }
  let apportion_meter_type={
    1:"纯用量分摊",
    2:"线损分摊"
  }
  let order_list=ret.order_list||[];
  let order_list_one=order_list[0]||{};
  return{
    id:ret.id+'',
    name: ret.name||'',
    number:ret.number||'',
    upid:ret.upid,
    children_count:ret.children_count||0,
    energy:energy_obj[ret.energy*1]||'未设置',
    apportion_meter_type:apportion_meter_type[ret.apportion_meter_type*1]||'未设置',//仪表分摊类型：1分摊表、2线损表
    apportion_type:apportion_type_obj[ret.apportion_type]||'未设置',//分摊模式
    customer_count:ret.customer_count||'',
    dosage_number: order_list_one.dosage_number||'',
    x_only_dosage_number:order_list_one.x_only_dosage_number||'',
    x_total_dosage_number:order_list_one.x_total_dosage_number||'',
    proportion_value:order_list_one.proportion_value||'',
    proportion_total:order_list_one.proportion_total||'',
    proportion:order_list_one.proportion||'',
    mol_apportion_type:apportion_type_obj[ret.mol_apportion_type]||'未设置',
    x_dosage_number:order_list_one.x_dosage_number||'',
    read_number:order_list_one.read_number||'',
    last_read_number:order_list_one.last_read_number||'',
    dosage_fun_name:order_list_one.dosage_fun_name||'',
    current_price:order_list_one.current_price||'',
    xs_accumulate_dosage_number:order_list_one.xs_accumulate_dosage_number||'',
    xs_accumulate_amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.xs_accumulate_amount*1)),0)),//ret.xs_accumulate_amount
    total_dosage_number:order_list_one.total_dosage_number||'',
    total_amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.total_amount*1)),0)),//ret.total_amount
    amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.amount*1)),0)),//ret.amount
    meter_amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.meter_amount*1)),0)),//ret.meter_amount
    x_amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.x_amount*1)),0)),//ret.x_amount
    allocated_amount:toFixed(order_list.reduce((pre,cur)=>(pre+(cur.allocated_amount*1)),0)),//ret.allocated_amount
    order_list:order_list,
  }
}

function getTree(upid,list=[]){
  let _list=list.filter(re=>re.upid==upid);
  return _list.map(ret=>{
    return meterOrderItem(ret)
  })
}
function getTreeAll(upid,list=[]){
  let root_list=getTree(upid,list)
  root_list=root_list.map(re=>{
    let ls=getTree(re.id,list);
    if(ls.length>0){
      re.children=getTreeAll(re.id,list);
    }
    return re;
  })
  return root_list
}

function getHeaderTree(upid,list=[]) {
  let header_list=list.filter(ret=>ret.id==upid).map(ret=>{
    return meterOrderItem(ret)
  })
  header_list.map(ret=>{
    let ls=getTree(ret.id,list);
    if(ls.length>0){
      ret.children=getTreeAll(ret.id,list);
    }
    return ret;
  })
  return header_list
}

// 保留两位小数
function toFixed(num) {
  return Math.round(num * 10000) / 10000;
}

</script>

<style lang="scss" scoped>
$layout_height:calc(100vh - 10px) ;
.MeterViewDiagram{
  .MeterViewDiagram-header{
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 9;
  }
  .MeterTreeWin{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9;
    //height: $layout_height;
  }
  #mountNode-order{
    height: $layout_height;
    /* 提示框的样式 */
    >>>.g6-tooltip {
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      font-size: 12px;
      color: #545454;
      background-color: rgba(255, 255, 255, 0.9);
      padding: 10px 8px;
      box-shadow: rgb(174, 174, 174) 0px 0px 10px;
    }
    >>>.g6-component-contextmenu{
      padding: 0;
      ul {
        list-style-type: none;
        left: -150px;
        margin: 0;
        padding: 0;
        background-color: rgba(255, 255, 255, 0.9);
        border-radius: 4px;
        font-size: 14px;
        color: #545454;
        li {
          cursor: pointer;
          list-style: none;
          padding: 5px 10px;
          border-bottom: 1px solid #e1e1e1;
          &:hover {
            background-color: #409eff;
            color: #ffffff;
          }
          &:last-child{
            border-bottom:0;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/components/MeterOrderDiagram.vue